import { Divider, Image, Modal, Spin, Space, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import Dragger from 'antd/lib/upload/Dragger';
import { InboxOutlined } from '@ant-design/icons';
import FormHelper from '../../../../../../../helpers/FormHelper';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from '../../../../../../../hooks/useNavigate';
import UIHelper from '../../../../../../../helpers/UIHelper';
import Button from '../../../../../../../components/button';
import { Input } from 'antd';
import styles from '../style.module.scss';

const { TextArea } = Input;

const ShowModal = ({
  isModalOpen,
  setIsModalOpen,
  onUploadFile,
  item,
  loading,
  handleDeleteImage,
  onSaveImageNote,
}) => {
  const [note, setNote] = useState(item.image_note);
  const history = useNavigate();
  const { pathname } = useLocation();
  const { id } = useParams();
  const handleOk = () => {
    history(UIHelper.getListRoute(pathname));
  };
  const handleCancel = () => {
    history(UIHelper.getListRoute(pathname));
  };

  const props = {
    fileList: [],
    name: 'file',
    multiple: false,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info) {
      onUploadFile(id, info.file);
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    beforeUpload: FormHelper.beforeUpload,
  };

  useEffect(() => {
    setNote(item.image_note);
  }, [item.image_note]);

  return (
    <Modal
      hideOkBtn={true}
      footer={null}
      title='Schema flusso'
      onOk={handleOk}
      onCancel={handleCancel}
      visible={true}
    >
      {item.image && (
        <>
          <Image src={item.image} />
          <Typography.Title level={5}>{item.image_note}</Typography.Title>
          <Divider />
        </>
      )}
      {item.can_update && (
        <Spin spinning={loading}>
          <Space direction={'vertical'} className={styles.spaceImage}>
            <Typography level={5}>Nome notifica</Typography>
            <TextArea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={4}
              placeholder='Nome notifica'
            />
            <Button
              type='primary'
              onClick={() => {
                onSaveImageNote(id, note);
              }}
              loading={loading}
            >
              Salva
            </Button>
          </Space>
          <Divider />
          <Button type='primary' onClick={handleDeleteImage} loading={loading}>
            Cancella immagine
          </Button>
          <Divider />
          <Dragger {...props}>
            <p className='ant-upload-drag-icon'>
              <InboxOutlined />
            </p>
            <p className='ant-upload-text'>
            Clicca per sfogliare il file oppure trascinalo in questa area.
            </p>
          </Dragger>
        </Spin>
      )}
    </Modal>
  );
};
export default ShowModal;
